declare const GUTTER_HORIZONTAL: {
  l: number;
  m: number;
  s: number;
  xs: number;
  0: number;
  24: number;
};

export type RowSize = keyof typeof GUTTER_HORIZONTAL;

export enum Theme {
  DARK = 'dark',
  LIGHT = 'light',
}
